<template>
    <div :id="page_slug">
        <div class="crumbs-bar">
            <el-row>
                <el-col :span="12">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ name: 'ProductCategoryList' }">Product Categories</el-breadcrumb-item>
                    <el-breadcrumb-item>Add</el-breadcrumb-item>
                </el-breadcrumb>        
                </el-col>      
            </el-row>
        </div>

        <el-form 
            ref="category" 
            :rules="rules.category"
            :model="category"
            :label-position="label_position">
                
            <el-form-item label="Name" prop="name">
                <el-input v-model="category.name"></el-input>
            </el-form-item>

            <el-form-item label="Sort Order" prop="sort_order">
                <el-input-number controls-position="right" :min="0" v-model="category.sort_order" :value="category.sort_order"></el-input-number>
            </el-form-item>

            <el-form-item label="Is Hidden" prop="is_hidden">
                <el-switch
                    v-model="category.is_hidden"
                    :active-value="1"
                    :inactive-value="0">
                </el-switch>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="addCategory('category')">Add</el-button>
            </el-form-item>

        </el-form>

        <pre>{{$data}}</pre>
    </div>
</template>

<style>
</style>

<script>
    import Config from '@/store/Config.js';
    import Utils from '@/components/utils/Utils.js';
    import Auth from '@/components/auth/AuthCheck.js';

    export default {
        data: function() {
            return {
                config: Config.config,
                page_alias: 'Add category',
                page_slug: 'add-category',
                label_position: 'top',
                rules: {
                    category: {
                        name: [
                            {required: true, message: 'Please Enter Name', trigger: 'blur'}
                        ],
                        sort_order: [
                            {required: true, message: 'Please Enter Sort Order', trigger: 'blur' },
                            {type: 'integer', message: 'Please Enter Number', trigger: 'blur'}
                        ],
                    }
                },  
                category: {
                    name: '',
                    sort_order: 0,
                    is_hidden: '',
                    updated_user_id: '',
                    created_user_id: ''
                }
            };
        },

        mounted: function() {
            const me = this;
        },

        methods: {
            addCategory: function(formName) {
                console.log('get category function');
                const me = this;
                me.$refs[formName].validate((valid) => {
                    if (valid) {
                        var jwt = Utils.decodejwt();
                        me.category.updated_user_id = jwt.sub;
                        me.category.created_user_id = jwt.sub;
                        me.$http.post(me.config.api + 'productCategory', me.category).then(
                            response => {
                            console.log('success putting data')  
                            console.log(response.status);
                            console.log(response.statusText);
                            me.$notify({
                                title: 'Success',
                                message: 'The Category Was Added',
                                type: 'success'
                            });
                            me.$router.push({name: 'ProductCategoryList'});
                        }, response => {
                            console.log('Error Getting Data');
                            console.log(response.status);
                            console.log(response.statusText);
                        });
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });                    
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/pages/product-categories/ProductCategoryAdd.vue